import { render, staticRenderFns } from "@/templates/file/fileView.html?vue&type=template&id=ca576b22&scoped=true&"
import script from "./FileView.vue?vue&type=script&lang=js&"
export * from "./FileView.vue?vue&type=script&lang=js&"
import style0 from "./FileView.vue?vue&type=style&index=0&id=ca576b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca576b22",
  null
  
)

export default component.exports